import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";

const Contact = () => {
  const form = useRef();

  const location = useLocation();
  const message = location?.state?.message;

  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    contact: "",
    message: message ?? "",
  });
  const [errorStatus, setErrorStatus] = useState({
    name: false,
    email: false,
    contact: false,
    message: false,
  });
  const [sendStatus, setSendStatus] = useState(false);

  const sendEmail = (e) => {
    setSendStatus(true);
    e.preventDefault();
    console.log(formValues);
    if (
      formValues.name !== "" &&
      formValues.email !== "" &&
      formValues.contact !== "" &&
      formValues.message !== ""
    ) {
      emailjs
        .sendForm(
          "service_lpmjmyb",
          "template_jz5wm4h",
          form.current,
          "89d7VN0gJPNJ_nun-"
        )
        .then(
          (result) => {
            // console.log(result.text)
            if (result.text === "OK") {
              toast.success("Massage sent successfully!", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
              setFormValues({
                name: "",
                email: "",
                message: "",
                contact: "",
              });
              setErrorStatus({
                name: false,
                email: false,
                message: false,
                contact: false,
              });
              setSendStatus(false);
            }
          },
          (error) => {
            console.log(error.text);
            toast.error("Something went wront try again!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setFormValues({
              name: "",
              email: "",
              message: "",
              contact: "",
            });
            setErrorStatus({
              name: false,
              email: false,
              message: false,
              contact: false,
            });
            setSendStatus(false);
          }
        );
    } else {
      let validEmailRegex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      setErrorStatus({
        name: formValues.name === "",
        email: !validEmailRegex.test(formValues.email),
        message: formValues.message === "",
        contact: formValues.contact === "",
      });
      console.log(errorStatus);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-orange-400">Get</span> In Touch
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Ready to transform your kitchen? Contact us today and let our
              experts help you find the perfect appliances for your home.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Expert Support
                </h3>
                <p className="text-lg">
                  Our team is here to help you every step of the way
                </p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Quick Response
                </h3>
                <p className="text-lg">Get back to you within 24 hours</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Free Consultation
                </h3>
                <p className="text-lg">Professional advice at no cost</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Information Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
              Contact Information
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Reach out to us through any of these channels. We're here to help
              you with all your kitchen appliance needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Address */}
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-8 border border-indigo-200">
              <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-6 mx-auto">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  className="w-8 h-8 text-indigo-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-indigo-600 mb-4 text-center">
                Visit Us
              </h3>
              <p className="text-gray-700 text-center">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.google.com/maps/place/23%C2%B006'33.5%22N+72%C2%B035'15.5%22E/@23.1093029,72.5850669,17z/data=!3m1!4b1!4m4!3m3!8m2!3d23.1093029!4d72.5876418?hl=en&entry=ttu&g_ep=EgoyMDI1MDczMC4wIKXMDSoASAFQAw%3D%3D"
                  className="hover:text-indigo-600 transition-colors"
                >
                  121 FF SARJAN -II COMPLEX, OPP.SAMRUDHHI COMPLEX, NEW CG ROAD,
                  CHANDKHEDA, AHMEDABAD - 382424
                </a>
              </p>
            </div>

            {/* Phone */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl p-8 border border-orange-200">
              <div className="flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-6 mx-auto">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  className="w-8 h-8 text-orange-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-orange-600 mb-4 text-center">
                Call Us
              </h3>
              <div className="text-center space-y-2">
                <p className="text-gray-700">
                  <a
                    href="tel:+919558886009"
                    className="hover:text-orange-600 transition-colors"
                  >
                    +91 955 888 6009
                  </a>
                </p>
                <p className="text-gray-700">
                  <a
                    href="tel:+917859831208"
                    className="hover:text-orange-600 transition-colors"
                  >
                    +91 785 983 1208
                  </a>
                </p>
              </div>
            </div>

            {/* Email */}
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 rounded-xl p-8 border border-indigo-200">
              <div className="flex items-center justify-center w-16 h-16 bg-indigo-100 rounded-full mb-6 mx-auto">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  className="w-8 h-8 text-indigo-600"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-indigo-600 mb-4 text-center">
                Email Us
              </h3>
              <p className="text-gray-700 text-center">
                <a
                  href="mailto:info@alphaappliances.in"
                  className="hover:text-indigo-600 transition-colors"
                >
                  info@alphaappliences.in
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
              Send Us a Message
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Fill out the form below and our team will get back to you within
              24 hours.
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
              <form ref={form} onSubmit={sendEmail} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="name"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Full Name
                    </label>
                    <input
                      type="text"
                      name="from_name"
                      id="name"
                      placeholder="Enter your full name"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                      value={formValues.name}
                      required
                      onChange={(e) => {
                        setFormValues({ ...formValues, name: e.target.value });
                      }}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium text-gray-700 mb-2"
                    >
                      Email Address
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter your email"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                      required
                      value={formValues.email}
                      onChange={(e) => {
                        setFormValues({ ...formValues, email: e.target.value });
                      }}
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="tel"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    name="tel"
                    id="tel"
                    placeholder="Enter your phone number"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
                    required
                    value={formValues.contact}
                    onChange={(e) => {
                      setFormValues({ ...formValues, contact: e.target.value });
                    }}
                  />
                </div>
                <div>
                  <label
                    htmlFor="message"
                    className="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Message
                  </label>
                  <textarea
                    name="message"
                    id="message"
                    rows="6"
                    placeholder="Tell us about your inquiry..."
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors resize-none"
                    required
                    value={formValues.message}
                    onChange={(e) => {
                      setFormValues({ ...formValues, message: e.target.value });
                    }}
                  />
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 px-8 rounded-lg transition-colors duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                    disabled={sendStatus}
                  >
                    {sendStatus ? (
                      <div className="flex items-center justify-center">
                        <svg
                          className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                        Sending...
                      </div>
                    ) : (
                      "Send Message"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Contact;
